import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { MyGamesSource } from '../../application/models';

@Component({
  selector: 'lib-my-games-segment',
  templateUrl: './my-games-segment.component.html',
  styleUrls: ['./my-games-segment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: []
})
export class MyGamesSegmentComponent {
  readonly source: InputSignal<MyGamesSource> = input.required<MyGamesSource>();
  readonly sourceChange: OutputEmitterRef<MyGamesSource> = output<MyGamesSource>();

  protected readonly MyGamesSource: typeof MyGamesSource = MyGamesSource;

  select(source: MyGamesSource): void {
    if (source === this.source()) return;
    this.sourceChange.emit(source);
  }
}
